import React, { useEffect, useRef, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { MemoryRouter } from 'react-router-dom';
import { Alert, Spin } from 'antd';
import { AuthProvider } from '../../contexts/AuthContext';
import { WorkbenchContext } from '../../contexts/WorkbenchContext';

export default function WorkbenchModule({ schoolId, schoolName, path }) {
  const container = useRef(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  useEffect(() => {
    let active = true, root;
    setLoading(true); setError(false);
    // A separate React root gives existing edit/detail routes a MemoryRouter
    // without nesting routers or changing navigation in standalone pages.
    import('../../App').then(({ ApplicationRoutes }) => {
      if (!active) return;
      const url = new URL(path, 'http://workbench.local');
      url.searchParams.set('schoolId', String(schoolId));
      root = createRoot(container.current);
      root.render(<WorkbenchContext.Provider value={{ schoolId: String(schoolId), schoolName }}>
        <AuthProvider><MemoryRouter initialEntries={[url.pathname + url.search]}>
          <ApplicationRoutes />
        </MemoryRouter></AuthProvider>
      </WorkbenchContext.Provider>);
      setLoading(false);
    }).catch(() => { if (active) { setError(true); setLoading(false); } });
    return () => { active = false; if (root) queueMicrotask(() => root.unmount()); };
  }, [schoolId, schoolName, path]);
  return <div className="sw-embedded-module">
    {loading && <Spin tip="加载操作区"><div style={{ minHeight: 80 }} /></Spin>}
    {error && <Alert type="error" showIcon message="操作区加载失败，请收起后重试" />}
    <div ref={container} />
  </div>;
}
